<template>
  <div class="droptext" :class="{ 'droptext--opened' : opened }">
    <div class="droptext__title" :style="{color: textColor}" :class="{'droptext__title--bold': isTextBold}" @click="onClick">

      <div class="droptext__icon" v-if="icon">
        <img :src=icon alt="icon" />
      </div>

      <slot name="title"></slot>
    </div>
    <div class="droptext__content">
      <div class="text">
        <slot name="text"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'droptext',
  props: {
    isTextBold: {
      default: true,
      type: Boolean
    },
    textColor: {
      default: '#000000',
      type: String
    },
    icon: {
      default: '/assets/images/favicon-32x32.png',
      type: String
    },
  },
  data() {
    return {
      opened: false
    }
  },
  methods: {
    onClick() {
      this.opened = !this.opened
    }
  }
}
</script>

<style lang="scss" scoped>
  .droptext {
    $container: &;
    &__title {
      display: flex;
      align-items: center;
      position: relative;
      font-size: 1.4em;
      font-weight: 400;
      text-shadow: #fff 0px 1px 1px;
      padding: 34px 50px 34px 0;
      &--bold {
        font-weight: 700;
        text-stroke: 0.45px;
        -webkit-text-stroke: 0.45px;
      }
      &:hover {
        cursor: pointer;
      }
      &:after {
        content: '';
        position: absolute;
        right: 0;
        border: 9px solid transparent;
        border-top: 10px solid #9ddda9;
        border-bottom: 0 none;
      }
    }
  	&__icon {
      margin-right: 20px;
    }
    &__content {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.15s ease-out;

      & .text {
        font-size: 1.3em;
        line-height: 1.3em;
        color: #999;
        padding-bottom: 34px;
      }
    }

    // --- Modifiers

    &--opened {

      #{$container}__title {
        &:after {
          border: 9px solid transparent;
          border-bottom: 10px solid #9ddda9;
          border-top: 0 none;
        }
      }

      #{$container}__content {
        max-height: 5000px;
        transition: max-height 0.25s ease-in;
      }
    }
  }
</style>
